export const API_URLS = {
    LOGIN: `${process.env.REACT_APP_API_BASE_URL}/${process.env.REACT_APP_LOGIN_URL}`,
    REFRESH: `${process.env.REACT_APP_API_BASE_URL}/${process.env.REACT_APP_REFRESH_URL || 'api/v2/auth/refresh'}`,
    PAUSE_NOTIFICATIONS: `${process.env.REACT_APP_API_BASE_URL}/api/notifications/pause`,
    STREAM_TOKEN: `${process.env.REACT_APP_API_BASE_URL}/${process.env.REACT_APP_TOKEN_URL}`,
    STREAM_MESSAGE: `${process.env.REACT_APP_API_BASE_URL}/api/v1/stream-message/{0}`,
    BANNER: `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_BANNER_URL}`,
    UNSUBSCRIBE_SUCCESS: process.env.REACT_APP_UNSUBSCRIBE_SUCCESS_URL,
    UNSUBSCRIBE: process.env.REACT_APP_UNSUBSCRIBE_URL,
    FIREBASE_EVENT_SCRIBE: process.env.REACT_APP_FIREBASE_EVENT_SCRIBE_URL, 
    FCM_SAVE: `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_FCM_SAVE_URL}`,  
    FCM_DELETE: `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_FCM_DELETE_URL}`,
    FCM_GET: `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_FCM_GET_URL}`,
    FCM_EXISTS: `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_FCM_EXISTS_URL}`,
    APP_VIEW_APPOINTMENT_IFRAME_URL: `${process.env.REACT_APP_FLUTTER_ORIGIN}/${process.env.REACT_APP_VIEW_APPOINTMENT_SUMMARY_IFRAME_URL}`,
    APP_FLUTTER_ORIGIN :`${process.env.REACT_APP_FLUTTER_ORIGIN}`,
    APP_APPOINTMENT_IFRAME_URL: `${process.env.REACT_APP_FLUTTER_ORIGIN}/${process.env.REACT_APP_APPOINTMENT_IFRAME_URL}`,
    APP_ENABLE_SCHEDULE_APPOINTMENT: process.env.REACT_APP_FEATURE_SCHEDULE_APPOINTMENT,
};